export const USE_NEW_CHECKOUT_FEATURE_FLAG = 'use_new_checkout_20231212_hz55';
